import slice from './slice';

export const {
    addStructure, changeProteinFamily,
    changeTarget, removeStructure,
    setCompoundTableState, setScoringTableState,
    setJobsCompoundsTableState,
    setSidePanelWidth,
    removeAllStructures, reset,
    setCoralMapState, setTableState,
    setProteinTarget,
    setAllTargetInfo, setActiveChart,
    setTargetsTableState,
} = slice.actions;

export default slice.reducer;
